import { render, staticRenderFns } from "./PreCadastroCliente.vue?vue&type=template&id=4322ffca&scoped=true&"
import script from "./PreCadastroCliente.vue?vue&type=script&lang=js&"
export * from "./PreCadastroCliente.vue?vue&type=script&lang=js&"
import style0 from "./PreCadastroCliente.vue?vue&type=style&index=0&id=4322ffca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4322ffca",
  null
  
)

export default component.exports